import { render, staticRenderFns } from "./informationDetailsSub.component.vue?vue&type=template&id=08cb030c"
import script from "./informationDetailsSub.component.ts?vue&type=script&lang=ts&external"
export * from "./informationDetailsSub.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08cb030c')) {
      api.createRecord('08cb030c', component.options)
    } else {
      api.reload('08cb030c', component.options)
    }
    module.hot.accept("./informationDetailsSub.component.vue?vue&type=template&id=08cb030c", function () {
      api.rerender('08cb030c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/informationDetails/informationDetailsSub.component.vue"
export default component.exports